import Loader from '../../src/assets/loading.gif';

export const Images = {
  Loader
};
